export default __webpack_public_path__ + "static/media/FAX-example.84358f05.pdf";